var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"homepage-title display-1 text-center tw-relative",class:{ 'homepage-title--dark': _vm.dark}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }